import { createContext } from 'react'

const UserInfoCustomizedStyles = createContext()

export default UserInfoCustomizedStyles
